import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SEARCH_UI_MARKER_PROPS, isInsideSearchUI } from "@/components/common/GNB/constants/searchMarker";
import { useSearchDialog } from "@/components/common/GNB/hooks";
import { SearchRecommendDropdown } from "@/components/SearchRecommend/SearchRecommendDropdown";
import { motion } from "framer-motion";
import { useEffect } from "react";
import GNBSearchInput from "./GNBSearchInput";
/**
 * GNB 검색창 컴포넌트
 * PC/태블릿 GNB에서 사용
 * 검색 입력창 + 드롭다운 추천 검색어
 */ const GNBSearchBox = (param)=>{
    let { openWidth =400 , closedWidth =320  } = param;
    const { isOpen , open , close , searchTerm , setSearchTerm , clearSearchTerm , submit , subject , setSubject , recommendList , onRecommendSelect  } = useSearchDialog();
    // 외부 클릭 감지 - 검색 드롭다운
    // 반응형으로 이 컴포넌트가 여러 개 동시에 마운트되므로,
    // 자기 컨테이너가 아닌 "검색 UI 전체"(마커) 기준으로 판정해야 한다
    useEffect(()=>{
        const handleClickOutside = (event)=>{
            if (!isInsideSearchUI(event.target)) {
                close();
            }
        };
        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        isOpen,
        close
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        ...SEARCH_UI_MARKER_PROPS,
        className: "relative",
        children: [
            /*#__PURE__*/ _jsx(motion.div, {
                animate: {
                    width: isOpen ? openWidth : closedWidth
                },
                transition: {
                    duration: 0.4,
                    ease: "easeOut"
                },
                style: {
                    minWidth: closedWidth
                },
                children: /*#__PURE__*/ _jsx(GNBSearchInput, {
                    value: searchTerm,
                    onChange: (e)=>setSearchTerm(e.target.value),
                    onClear: clearSearchTerm,
                    onSubmit: submit,
                    selectedSubject: subject,
                    onSubjectChange: setSubject,
                    placeholder: recommendList.placeHolder,
                    isActive: isOpen,
                    onInputClick: open
                })
            }),
            /*#__PURE__*/ _jsx(SearchRecommendDropdown, {
                isOpen: isOpen,
                currentSubject: subject,
                handleCurrentSubject: setSubject,
                onClick: onRecommendSelect,
                recommendSearchTermList: recommendList,
                width: openWidth
            })
        ]
    });
};
export default GNBSearchBox;
